export enum UserRole {
  Agent = 'AGENT',
  Admin = 'ADMIN',
}

export enum PartnerTeam {
  IndirectChannel = 'INDIRECT_CHANNEL',
}

export enum PartnerProduct {
  AutoFinancing = 'AUTO_FINANCING',
  AutoRefinancing = 'AUTO_REFINANCING',
  HomeRefinancing = 'HOME_REFINANCING',
}

export enum PartnerType {
  Personalized = 'PERSONALIZED',
  Default = 'DEFAULT',
}

export enum Channels {
  Portal = 'PARTNER_PORTAL',
  API = 'API',
  TaggedLink = 'TAGGED_LINK',
  Default = 'DEFAULT',
  ShopkeeperPortal = 'SHOPKEEPER_PORTAL',
}
